<script setup>
import { computed } from 'vue';
import CurrentConditionsGaugeWindMarker from '@/components/CurrentConditionsGaugeWindMarker.vue';

const props = defineProps({
  spot: {
    type: Object,
    required: true
  },
  distanceUnits: {
    type: String,
    default: 'mi'
  }
});

const ORIGIN = window.location.origin;

const station = computed(() => props.spot.stations[0]);
const stationDataValues = computed(() => station.value.data_values[0]);
const windDirection = computed(() => stationDataValues.value[props.spot.data_names.indexOf('dir')]);
const isNowcast = computed(() => station.value.type === 100 || station.value.type === 101);
const distance = computed(() => `${Math.floor(props.spot.distance)}${props.distanceUnits}`)

const memberLevel = computed(() => {
  const provider = station.value.provider;
  return (provider === 1 || provider === 1370) ? 'Pro' : 'Plus';
});

const upgradeLevels = computed(() => {
  return memberLevel.value === 'Pro' 
    ? 'Pro/Gold' 
    : memberLevel.value === 'Plus'
    ? 'Plus/Pro/Gold'
    : 'Free'
});
</script>

<template>
  <a :href="`${ORIGIN}/spot/${props.spot.spot_id}`" class="jwx-upgrade-spot">
    <div class="jwx-upgrade-spot__wind-marker" data-mini="true">
      <CurrentConditionsGaugeWindMarker
        :iconColor="props.spot.icon_color"
        :iconType="props.spot.icon_type"
        :windDir="windDirection"
        :status="station.status_id"
        :isNowcast="isNowcast"
        :upgrade="[]"
      />
    </div>
    <div class="jwx-upgrade-spot__info">
      <h4 class="jwx-upgrade-spot__name">{{ spot.name }}</h4>
      <p class="jwx-upgrade-spot__upgrade-levels">{{  upgradeLevels }} members</p>
    </div>
    <div class="jwx-upgrade-spot__meta">
      <p class="jwx-upgrade-spot__member-level" :data-member-level="memberLevel">{{ memberLevel }}</p>
      <p class="jwx-upgrade-spot__distance">{{ distance }}</p>
    </div>
  </a>
</template>
